import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=4ab654fc"
import script from "./checkBox.vue?vue&type=script&lang=js"
export * from "./checkBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab654fc')) {
      api.createRecord('4ab654fc', component.options)
    } else {
      api.reload('4ab654fc', component.options)
    }
    module.hot.accept("./checkBox.vue?vue&type=template&id=4ab654fc", function () {
      api.rerender('4ab654fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dictionary/checkBox.vue"
export default component.exports